import { useContext } from 'react';
import {
  TableContextValue,
  SearchFilters,
} from 'src/components/DataTable/types/DataTable';
import { DataTableContext } from 'src/components/DataTable/components/DataTableProvider/DataTableContext';

export function useDataTableContext<
  TData,
  TFilters = SearchFilters
>(): TableContextValue<TData, TFilters> {
  const context = useContext(DataTableContext);
  if (!context) {
    throw new Error(
      'useDataTableContext must be used within a DataTableProvider'
    );
  }
  return context as TableContextValue<TData, TFilters>;
}
